import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['María', 'Luciana', 'Valentina', 'Camila', 'Florencia', 'Agustina', 'Sofía', 'Carolina', 'Paula', 'Daniela', 'Romina', 'Julieta', 'Natalia', 'Micaela', 'Belén', 'Andrea', 'Gabriela', 'Laura', 'Mariana', 'Victoria'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Luis', 'Paraná', 'Formosa', 'Corrientes', 'San Rafael', 'Ushuaia'];
const packs = ['Sistema Pro', 'Registros Akáshicos Élite'];
function getRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomInterval() {
  return Math.floor(Math.random() * (80000 - 40000 + 1)) + 40000;
}
function getMinutesAgo() {
  return Math.floor(Math.random() * 15) + 1;
}
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    pack: '',
    minutes: 0
  });
  const showToast = useCallback(() => {
    setData({
      name: getRandom(names),
      city: getRandom(cities),
      pack: getRandom(packs),
      minutes: getMinutesAgo()
    });
    setVisible(true);
    setTimeout(() => setVisible(false), 4000);
  }, []);
  useEffect(() => {
    const firstTimeout = setTimeout(showToast, 8000);
    let intervalId: ReturnType<typeof setTimeout>;
    const scheduleNext = () => {
      intervalId = setTimeout(() => {
        showToast();
        scheduleNext();
      }, getRandomInterval());
    };
    const startInterval = setTimeout(() => {
      scheduleNext();
    }, 8000);
    return () => {
      clearTimeout(firstTimeout);
      clearTimeout(startInterval);
      clearTimeout(intervalId);
    };
  }, [showToast]);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-205">
      <AnimatePresence data-id="element-206">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 30
      }} className="pointer-events-auto bg-mystic-800 border border-mystic-700 rounded-xl px-4 py-3 shadow-lg shadow-black/30 max-w-xs" data-id="element-207">
            <div className="flex items-center gap-3" data-id="element-208">
              <div className="w-8 h-8 rounded-full bg-gold/20 flex items-center justify-center shrink-0" data-id="element-209">
                <span className="text-sm" data-id="element-210">🛒</span>
              </div>
              <div data-id="element-211">
                <p className="text-sm text-white font-medium leading-snug" data-id="element-212">
                  {data.name} de {data.city}
                </p>
                <p className="text-xs text-gray-400" data-id="element-213">
                  Compró{' '}
                  <span className="text-gold-light font-medium" data-id="element-214">
                    {data.pack}
                  </span>{' '}
                  hace {data.minutes} min
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}